import { jotaiStorage } from '../atom';

export const updateAccessToken = (access_token: string | null) => {
  jotaiStorage.setItem('access_token', access_token);
};

export const deleteAccessToken = () => {
  jotaiStorage.removeItem('access_token');
};
